import React, { lazy } from 'react';
// import { UploadValidationListing } from 'containers/SystemAdminModule/UOMModule/UploadValidationListing';

const TermsConditionsListing = lazy(() =>
  import(
    'containers/SystemAdminModule/TermsConditionsModule/TermsConditionsListing'
  ).then(module => ({
    default: module.TermsConditionsListing,
  })),
);

const TermsConditionsForm = lazy(() =>
  import(
    'containers/SystemAdminModule/TermsConditionsModule/TermsConditionsForm'
  ).then(module => ({
    default: module.TermsConditionsForm,
  })),
);

const termsConditionsRoutes = [
  {
    props: { exact: true, path: '/common-settings/terms-conditions' },
    component: <TermsConditionsListing />,
  },
  {
    props: { exact: true, path: '/common-settings/terms-conditions/:type' },
    component: <TermsConditionsForm />,
  },
  {
    props: { exact: true, path: '/common-settings/terms-conditions/:ID/:type' },
    component: <TermsConditionsForm />,
  },
];

export default termsConditionsRoutes;
